var _g, _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCSharp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 260,
    viewBox: "0 0 261 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_936_5336)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.2081,
    y: 36,
    width: 180,
    height: 180,
    rx: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.7081,
    y: 36.5,
    width: 179,
    height: 179,
    rx: 31.5,
    stroke: "#D9D9D9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M174.357 105.196C174.357 103.532 174.001 102.06 173.281 100.798C172.573 99.5561 171.514 98.5155 170.093 97.6927C158.365 90.93 146.625 84.1881 134.9 77.4185C131.739 75.5937 128.675 75.6605 125.537 77.5116C120.869 80.2643 97.4967 93.6549 90.5321 97.6889C87.6639 99.3497 86.2682 101.891 86.2675 105.193C86.263 118.793 86.2675 132.394 86.263 145.994C86.263 147.622 86.6046 149.065 87.293 150.308C88.0006 151.587 89.0747 152.657 90.5283 153.498C97.4933 157.532 120.869 170.922 125.536 173.675C128.675 175.528 131.739 175.594 134.901 173.769C146.626 166.999 158.367 160.257 170.097 153.494C171.55 152.653 172.625 151.583 173.332 150.305C174.02 149.061 174.362 147.619 174.362 145.99C174.362 145.99 174.362 118.797 174.357 105.196Z",
    fill: "#A179DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.447 125.461L87.293 150.308C88.0006 151.587 89.0747 152.657 90.5283 153.498C97.4933 157.532 120.869 170.922 125.536 173.675C128.675 175.527 131.739 175.594 134.901 173.768C146.626 166.999 158.367 160.257 170.097 153.494C171.55 152.653 172.625 151.583 173.332 150.305L130.447 125.461Z",
    fill: "#280068"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M174.358 105.196C174.357 103.531 174.001 102.06 173.281 100.798L130.447 125.461L173.332 150.305C174.02 149.061 174.361 147.618 174.362 145.99C174.362 145.99 174.362 118.797 174.358 105.196Z",
    fill: "#390091"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M155.855 116.172V120.816H160.499V116.172H162.822V120.816H167.466V123.139H162.822V127.783H167.466V130.105H162.822V134.749H160.499V130.105H155.855V134.749H153.533V130.105H148.889V127.783H153.533V123.139H148.889V120.816H153.533V116.172H155.855ZM160.499 123.138H155.855V127.783H160.499V123.138Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M130.542 92.847C142.656 92.847 153.232 99.426 158.898 109.205L158.842 109.111L144.589 117.318C141.781 112.563 136.633 109.354 130.728 109.288L130.542 109.287C121.536 109.287 114.236 116.588 114.236 125.593C114.233 128.431 114.974 131.221 116.386 133.683C119.197 138.59 124.481 141.899 130.542 141.899C136.641 141.899 141.955 138.548 144.751 133.589L144.683 133.708L158.914 141.952C153.311 151.649 142.88 158.207 130.907 158.338L130.542 158.34C118.39 158.34 107.783 151.72 102.132 141.889C99.3736 137.09 97.7952 131.526 97.7952 125.593C97.7952 107.508 112.456 92.8467 130.542 92.8467L130.542 92.847Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_936_5336",
    x: 0.20813,
    y: 0,
    width: 260,
    height: 260,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0367917 0 0 0 0 0.0348958 0 0 0 0 0.0484375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_936_5336"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_936_5336",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCSharp);
export default __webpack_public_path__ + "static/media/c-sharp.b88b10fbdb1090846be3780859a2cb9d.svg";
export { ForwardRef as ReactComponent };